import Translation from "../General/Translation";
import React from "react";

const DateTimeDisplay = ({ value, type, translation, id }) => {
    return (
      <div className={'countdown-part'}>
        <span className="text-large-medium"><Translation id={id} trans={translation}>{type}</Translation></span>
        <p className="title-xlarge">{value}</p>
      </div>
    );
  };
  

const ShowCounter = ({ days, hours, minutes, seconds, translation }) => {
    return (
      <div className="countdown">
            <DateTimeDisplay value={days} translation={translation} type={'Days'} id={'countdownDays'}/>
            <DateTimeDisplay value={hours} translation={translation} type={'Hours'} id={'countdownHours'}/>
            <DateTimeDisplay value={minutes} translation={translation} type={'Mins'} id={'countdownMinutes'}/>
            <DateTimeDisplay value={seconds} translation={translation} type={'Sec'} id={'countdownSeconds'}/>
      </div>
    );
};

export default ShowCounter